import { baseURL } from '@/services/app.service';
import { map, isEmpty } from 'lodash';
var imageName = 'original.png';
var menuImageMixin = {
    methods: {
        hasMenuImage: function (obj) {
            var images = obj.images;
            if (!images) {
                return '';
            }
            if (images.hasOwnProperty(imageName)) {
                return 'menu-data-has-image';
            }
            return '';
        },
        getMenuImage: function (obj) {
            var images = obj.images;
            if (!images) {
                return '';
            }
            if (images.hasOwnProperty(imageName)) {
                var imagePath = images[imageName];
                var imageURL = "" + baseURL + imagePath;
                return imageURL;
            }
            return null;
        },
        handleDynamicImageError: function () {
            return "this.parentElement.classList.add('error');";
        },
        getMenuImageHTML: function (obj) {
            var imageUrl = this.getMenuImage(obj);
            var displayNoImage = (this.$useItemImages) ? "<div class=\"no-image\"></div>" : '';
            if (!imageUrl) {
                return '';
            }
            else {
                return "\n\t\t\t\t" + displayNoImage + "\n\t\t\t\t<img alt=\"" + obj.name + " image\" onerror=\"" + this.handleDynamicImageError() + "\" class=\"menu-data-tab-image-prefix\" src=" + imageUrl + " />";
            }
        },
        getChoiceImagesForOption: function (option) {
            var _this = this;
            var choices = option.choices;
            if (isEmpty(choices)) {
                return false;
            }
            var choiceImages = map(choices, function (choice) {
                var menuImage = _this.getMenuImage(choice);
                return {
                    imageUrl: menuImage,
                    choice: choice,
                };
            });
            return choiceImages;
        }
    },
};
export default menuImageMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/menuImageMixin.ts
// module id = 03wz
// module chunks = 18